<template>
    <LegalDocument title="Podmienky spracúvania osobných údajov na GROWNi.sk" :html="privacyHtml" />
</template>

<script setup lang="ts">
import privacyHtml from '@/assets/legal/ochrana-sukromia.html?raw'
import LegalDocument from '@/components/legal/LegalDocument.vue'

definePageMeta({
    layout: 'default'
})

useHead({
    title: 'Ochrana súkromia | GROWNi',
    meta: [
        {
            name: 'description',
            content: 'Ochrana súkromia a spracovanie osobných údajov na platforme GROWNi'
        }
    ]
})
</script>
